import { render, staticRenderFns } from "./alarmClient.vue?vue&type=template&id=e64dcb08&scoped=true&"
import script from "./alarmClient.vue?vue&type=script&lang=js&"
export * from "./alarmClient.vue?vue&type=script&lang=js&"
import style0 from "./alarmClient.vue?vue&type=style&index=0&id=e64dcb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64dcb08",
  null
  
)

export default component.exports